const plansData = [
  {
    id: 1,
    planName: 'Simpra Advantage (PPO I-SNP)',
    shortPlanName: 'Simpra Advantage',
    planAbbreviation: 'SIMPRA',
    state: 'Alabama',
    stateAbbreviation: 'AL',
    planType: 'PPO I-SNP',
    planSite: 'simpra.com',
    contractId: 'H4091',
    ipdDisclaimerLink: 'https://simpra.com/2024-directory-preamble-of-alabama',
    ipdDisclaimerLink2: 'https://simpra.com/2025-directory-preamble-of-alabama',
    formularyDisclaimerLink: 'https://simpra.com/2023-formulary-preamble-of-alabama-simpra-advantage-ppo-i-snp',
    formularyDisclaimerLink2: '',
    formularyTier: 1,
    styleTheme: 'simpra-theme'
  },
  {
    id: 2,
    planName: 'Simpra Advantage (PPO D-SNP)',
    shortPlanName: 'Simpra Advantage',
    planAbbreviation: 'SIMPRA',
    state: 'Alabama',
    stateAbbreviation: 'AL',
    planType: 'PPO D-SNP',
    planSite: 'simpra.com',
    contractId: 'H4091',
    ipdDisclaimerLink: 'https://simpra.com/2024-directory-preamble-of-alabama',
    ipdDisclaimerLink2: 'https://simpra.com/2025-directory-preamble-of-alabama',
    formularyDisclaimerLink: 'https://simpra.com/2023-formulary-preamble-of-alabama-simpra-advantage-ppo-d-snp',
    formularyDisclaimerLink2: '',
    formularyTier: 1,
    styleTheme: 'simpra-theme'
  },
  {
    id: 3,
    planName: 'Simpra Advantage Premier (PPO I-SNP)',
    shortPlanName: 'Simpra Advantage',
    planAbbreviation: 'SIMPRA',
    state: 'Alabama',
    stateAbbreviation: 'AL',
    planType: 'PPO IE-SNP',
    planSite: 'simpra.com',
    contractId: 'H4091',
    ipdDisclaimerLink: 'https://simpra.com/2024-directory-preamble-of-alabama',
    ipdDisclaimerLink2: 'https://simpra.com/2025-directory-preamble-of-alabama',
    formularyDisclaimerLink: 'https://simpra.com/2023-formulary-preamble-of-alabama-simpra-advantage-premier-ppo-i-snp',
    formularyDisclaimerLink2: '',
    formularyTier: 5,
    styleTheme: 'simpra-theme'
  }
];

export default plansData;